import { render, staticRenderFns } from "./ClientBonitaPicker.vue?vue&type=template&id=314152aa&scoped=true&"
import script from "./ClientBonitaPicker.vue?vue&type=script&lang=js&"
export * from "./ClientBonitaPicker.vue?vue&type=script&lang=js&"
import style0 from "./ClientBonitaPicker.vue?vue&type=style&index=0&id=314152aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314152aa",
  null
  
)

export default component.exports